import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => {
  return {
    path: "pdf-dashboard",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(/* webpackChunkName: "pdf-dashboard" */ "./components"),
        ]).then(([importedModule0]) => {
          const component = importedModule0.default;
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [],
  };
};
